/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { NbIconLibraries } from '@nebular/theme';
import { personalizedIcons } from './pages/atendimento-whatsapp/chat/svgDocIcons';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit , OnDestroy{

  public iconesPersonalizados = personalizedIcons

  constructor(private analytics: AnalyticsService, private seoService: SeoService,
    public iconLibraries: NbIconLibraries
  ) {
    this.iconLibraries.registerSvgPack('personalized', {
      'pdf': this.iconesPersonalizados.pdf,
      'excel': this.iconesPersonalizados.excel,
      'word': this.iconesPersonalizados.word,
      'audio': this.iconesPersonalizados.audio,
      'image': this.iconesPersonalizados.image,
      'video': this.iconesPersonalizados.video,
      'padrao': this.iconesPersonalizados.padrao,
    })
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
  ngOnDestroy(): void {
    this.iconLibraries.setDefaultPack('eva')
  }
}
